export default __webpack_public_path__ + "img/eyfBwulg.89b54fb6.svg";